import PropTypes from "prop-types"
import React from "react"
import TextChartODD13GHGEmissionsEmployeeMolecule from "views/molecules/canvases/charts/TextChartODD13GHGEmissionsEmployeeMolecule"
import TextChartODD13EmissionsPerKeyMetricMolecule from "views/molecules/canvases/charts/TextChartODD13EmissionsPerKeyMetricMolecule"
import TextChartODD13GHGEmissionsMolecule from "views/molecules/canvases/charts/TextChartODD13GHGEmissionsMolecule"
import TextChartODD13EnergyMixMolecule from "views/molecules/canvases/charts/TextChartODD13EnergyMixMolecule"
import ScoreLayoutOrganism from "views/organisms/scores/ScoreLayoutOrganism"
import Objective13FlexibilityChartMapping from "views/molecules/charts/flexibility/Objective13FlexibilityChartMapping"
import TextChartODD13HighestITDomainEmissionsMolecule from "views/molecules/canvases/charts/TextChartODD13HighestITDomainEmissionsMolecule"
import ChartODD13GhgPerVisitOrFallbackMolecule from "views/molecules/canvases/charts/ChartODD13GhgPerVisitOrFallbackMolecule"
import { useAppContext } from "components/AppContext"
import { EnergyMixKpi } from "views/atoms/charts/kpi/energyMix/EnergyMixKpi"

const Objective13PartialScoreLayoutOrganism = ({ score }) => {
  const { currentRootNode, currentNode, score: globalScore } = useAppContext()

  const chart1TrendBadge = globalScore?.trend_badges?.odd13_CO2
  const chart2TrendBadge = globalScore?.trend_badges?.odd13_CO2_average_employee
  const chart5TrendBadge =
    globalScore?.trend_badges?.odd13_co2_domain_polluting_most
  const chart5KeyMetricTrendBadge =
    globalScore?.trend_badges?.odd13_emissions_per_key_metric
  const maturityTrendBadge = globalScore?.trend_badges?.odd13_maturity

  const chartKeys = score?.sdg13_partial_collect_charts || []
  const keyMetricFigure = Number(currentNode?.characteristic?.key_metric_figure)
  const keyMetricUnit = currentNode?.characteristic?.key_metric_unit
  // Available on program / project / phase / country_team when configured.
  const hasKeyMetric =
    Number.isFinite(keyMetricFigure) && keyMetricFigure > 0 && !!keyMetricUnit

  return (
    <ScoreLayoutOrganism
      maturity={score.odd13_maturity ?? 0}
      maturityTrendBadge={maturityTrendBadge}
      chart1={
        <TextChartODD13GHGEmissionsMolecule
          score={score}
          ghgEmissions={score?.odd13_CO2}
          hidePercentage={!score?.should_diplay_percentage}
          trendBadge={chart1TrendBadge}
        />
      }
      chart2={
        score?.node?.has_children ? (
          <TextChartODD13GHGEmissionsEmployeeMolecule
            score={score}
            trendBadge={chart2TrendBadge}
          />
        ) : (
          <TextChartODD13EnergyMixMolecule
            energyMixStatus={score?.odd13_energy_mix_status}
            energyMixValue={
              currentRootNode?.methodology === "bilan_carbone"
                ? Number(score?.odd13_energy_mix_value)
                : Number(score?.odd7_market_based_emission_factor)
            }
            country={EnergyMixKpi(score)}
            trendBadge={chart2TrendBadge}
          />
        )
      }
      chart3={
        <Objective13FlexibilityChartMapping
          chartKey={chartKeys[1]}
          envScore={score}
        />
      }
      chart4={
        <Objective13FlexibilityChartMapping
          chartKey={chartKeys[0]}
          envScore={score}
        />
      }
      chart5={
        hasKeyMetric ? (
          <TextChartODD13EmissionsPerKeyMetricMolecule
            emissions={Number(score?.odd13_CO2 || 0)}
            keyMetricFigure={keyMetricFigure}
            keyMetricUnit={keyMetricUnit}
            trendBadge={chart5KeyMetricTrendBadge}
          />
        ) : (
          <ChartODD13GhgPerVisitOrFallbackMolecule
            score={score}
            fallback={
              score?.node?.has_children ? (
                <TextChartODD13HighestITDomainEmissionsMolecule
                  score={score}
                  trendBadge={chart5TrendBadge}
                />
              ) : (
                <TextChartODD13GHGEmissionsEmployeeMolecule
                  score={score}
                  trendBadge={chart5TrendBadge}
                />
              )
            }
          />
        )
      }
      chart6={
        <Objective13FlexibilityChartMapping
          chartKey={chartKeys[2]}
          envScore={score}
        />
      }
    />
  )
}

Objective13PartialScoreLayoutOrganism.propTypes = {
  score: PropTypes.object.isRequired,
  trendBadges: PropTypes.object,
}

Objective13PartialScoreLayoutOrganism.defaultProps = {
  trendBadges: {},
}

export default Objective13PartialScoreLayoutOrganism
